import { ActionItemDialog, ActionItemDialogReadonly } from "../../action-items/components/action-item.dialog";
import { CommunicationDialog } from "../../communications/components/communications.dialog";
import { CommunicationDialogReadonly } from "../../communications/components/communications-readonly.dialog";
import { ContactDialog } from "../../contacts/components/contact-dialog";
import { CTMSSiteActionItemsSection } from "./site-action-items.section";
import { CTMSSiteCommunicationsSection } from "./site-communications.section";
import { CTMSSiteContactsSection } from "./site-contacts.section";
import { CTMSSiteAddressesSection } from "./site-addresses.section";
import { AddressDialog, AddressDialogReadonly } from "./site-address.dialog";
import { DeliverableDialog } from "./site-deliverable.dialog";
import { CTMSSiteDeliverablesSection } from "./site-deliverables.section";
import { SiteDetailsDialog } from "./site-details.dialog";
import { MilestoneDialog } from "./site-milestone.dialog";
import { CTMSSiteMilestonesSection } from "./site-milestones.section";
import { getData } from "./site.utilities";
import { StudyStatusDialog } from "./study-status.dialog";
import { CTMSSiteStaffSection } from "./site-staff.section";
import { StaffDialog } from "./site-staff.dialog";

export class CTMSSiteDetailsPage {

    siteId: number;
    siteName: string;
    token: string;

    deliverablesSection: CTMSSiteDeliverablesSection;
    milestonesSection: CTMSSiteMilestonesSection;
    actionItemSection: CTMSSiteActionItemsSection;
    communicationsSection: CTMSSiteCommunicationsSection;
    contactsSection: CTMSSiteContactsSection;
    staffSection: CTMSSiteStaffSection;
    addressesSection: CTMSSiteAddressesSection;

    siteDetailsDialog: SiteDetailsDialog;
    actionItemDialog: ActionItemDialog | ActionItemDialogReadonly;
    contactsDialog: ContactDialog;
    studyStatusDialog: StudyStatusDialog;
    milestoneDialog: MilestoneDialog;
    deliverableDialog: DeliverableDialog;
    communicationDialog: CommunicationDialog | CommunicationDialogReadonly;
    addressDialog: AddressDialog | AddressDialogReadonly;
    staffDialog: StaffDialog;

    isNonViewer: boolean;
    isManagementPlus: boolean;

    constructor(siteId: number, siteName: any, isNonViewer: boolean, isManagementPlus: boolean) {
        this.siteId = siteId;
        this.siteName = siteName;

        $(() => {
            this.token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');
            this.isNonViewer = isNonViewer === true;
            this.isManagementPlus = isManagementPlus === true; // why === true?

            this.deliverablesSection = new CTMSSiteDeliverablesSection(`/secure/ctms/sites/site-details?handler=Deliverables&id=${this.siteId}`, false, this.isNonViewer);
            this.milestonesSection = new CTMSSiteMilestonesSection(`/secure/ctms/sites/site-details?handler=Milestones&id=${this.siteId}`, [], this.isNonViewer);
            this.actionItemSection = new CTMSSiteActionItemsSection(`/secure/ctms/sites/site-details?handler=ActionItems&id=${this.siteId}`, false);
            this.communicationsSection = new CTMSSiteCommunicationsSection(`/secure/ctms/sites/site-details?handler=Communications&id=${this.siteId}`, false);
            this.contactsSection = new CTMSSiteContactsSection(`/secure/ctms/sites/site-details?handler=Contacts&id=${this.siteId}`);
            this.staffSection = new CTMSSiteStaffSection(`/secure/ctms/sites/site-details?handler=ActiveStaff&id=${this.siteId}`);
            this.addressesSection = new CTMSSiteAddressesSection(`/secure/ctms/sites/site-details?handler=Addresses&id=${this.siteId}`, false);

            this.initTables();
            this.loadData();
            this.bindDialogs();

        });

    }

    initTables() {




    }

    async loadData() {

        // Sections
        this.actionItemSection.loadData();
        this.deliverablesSection.loadData();
        this.milestonesSection.loadData();
        this.communicationsSection.loadData();
        this.contactsSection.loadData();
        this.staffSection.loadData();
        this.addressesSection.loadData();

        // Dialogs
        this.siteDetailsDialog = new SiteDetailsDialog(this.siteId);
        this.siteDetailsDialog.successCallback = this.siteDetailsDialogSuccess.bind(this);

        const dialogRefData = await getData('/secure/ctms/sites/site-details?handler=SharedReferenceData');

        // const aiRefData = await getData('/secure/ctms/action-items/action-items?handler=DialogReferenceData');
        if (this.isNonViewer) {
            this.actionItemDialog = new ActionItemDialog(
                dialogRefData.allActionItemsJson,
                dialogRefData.allActionItemTypesJson,
                dialogRefData.allActionItemStatusesJson,
                dialogRefData.allActionItemCriticalTypesJson,
                dialogRefData.allSites
            );
            this.actionItemDialog.successCallback = this.actionItemDialogSuccess.bind(this);
        } else {
            this.actionItemDialog = new ActionItemDialogReadonly(
                dialogRefData.allActionItemsJson,
                dialogRefData.allActionItemTypesJson,
                dialogRefData.allActionItemStatusesJson,
                dialogRefData.allActionItemCriticalTypesJson,
                dialogRefData.allSites
            );
        }

        // const contactRefData = await getData(`/secure/ctms/contacts/contacts?handler=DialogReferenceDataBySite&id=${this.siteId}`);
        this.contactsDialog = new ContactDialog(
            dialogRefData.allContactSites,
            dialogRefData.allJobFunctionsJson,
        );

        this.contactsDialog.successCallback = this.contactsDialogSuccess.bind(this);

        // const statusRefData = await getData(`/secure/ctms/sites/site-details?handler=StatusList&id=${this.siteId}`);
        this.studyStatusDialog = new StudyStatusDialog(dialogRefData.studyStatusList);
        this.studyStatusDialog.successCallback = this.statusDialogSuccess.bind(this);

        this.milestoneDialog = new MilestoneDialog(dialogRefData.milestoneStatusList, !this.isNonViewer);
        this.milestoneDialog.successCallback = this.milestoneDialogSuccess.bind(this);

        // const deliverableRefData = await getData(`/secure/ctms/sites/site-details?handler=DeliverableStatusList`);
        this.deliverableDialog = new DeliverableDialog(dialogRefData.deliverableStatusList, !this.isNonViewer);
        this.deliverableDialog.successCallback = this.deliverableDialogSuccess.bind(this);

        if (this.isNonViewer) {
            this.communicationDialog = new CommunicationDialog(
                dialogRefData.allCommunicationsJson,
                dialogRefData.allCommunicationTypesJson,
                dialogRefData.allCommunicationTopicsJson,
                dialogRefData.allCommunicationStatusesJson,
                dialogRefData.allAttachmentTypesJson,
                dialogRefData.allSites,
                dialogRefData.allContactsJson,
                dialogRefData.allUsersJson
            );
            this.communicationDialog.successCallback = this.communicationDialogSuccess.bind(this);
        } else {
            this.communicationDialog = new CommunicationDialogReadonly(
                dialogRefData.allCommunicationsJson,
                dialogRefData.allCommunicationTypesJson,
                dialogRefData.allCommunicationTopicsJson,
                dialogRefData.allCommunicationStatusesJson,
                dialogRefData.allAttachmentTypesJson,
                dialogRefData.allSites,
                dialogRefData.allContactsJson,
                dialogRefData.allUsersJson
            );
        }

        if (this.isNonViewer) {
            const allStaffJson = await getData('/secure/ctms/sites/site-details?handler=AllStaff');
            this.staffDialog = new StaffDialog(
                allStaffJson,
                this.siteId
            )
            this.staffDialog.successCallback = this.staffDialogSuccess.bind(this);
        }

        // Address Dialog
        if (this.isNonViewer) {
            this.addressDialog = new AddressDialog(
                dialogRefData.allAddressTypesJson,
                dialogRefData.allSites,
                this.siteId,
                this.siteName
            );
            this.addressDialog.successCallback = this.addressDialogSuccess.bind(this);
        } else {
            this.addressDialog = new AddressDialogReadonly(
                dialogRefData.allAddressTypesJson,
                dialogRefData.allSites,
                this.siteId
            );
        }

    }

    bindDialogs() {

        // Site Details
        $('#editSiteDialogButton').on('click', async () => {
            await this.siteDetailsDialog.resetDialog();
            $('#editSiteDialog').modal('show');
        });

        // Deliverables
        this.deliverablesSection.editCallback = (deliverable) => {
            this.deliverableDialog.resetDialog(deliverable);
            $('#editDeliverableDialog').modal('show');
        }

        this.deliverablesSection.addCallback = async (deliverable) => {
            // TODO Switch to modal instead of default confirm
            if (window.confirm(`Create a duplicate of ${deliverable.DeliverableName}?`)) {
                $.ajax({
                    url: `/secure/ctms/sites/site-details?handler=AddDeliverable`,
                    headers: { "RequestVerificationToken": this.token },
                    type: 'POST',
                    data: deliverable,
                    success: (resp) => {
                        this.deliverablesSection.loadData();
                    }
                });
            }
        }

        // Milestones
        this.milestonesSection.statusClick = (siteStudyId, statusId, studyName) => {
            this.studyStatusDialog.resetDialog(siteStudyId, statusId, studyName);
            $('#editStatusDialog').modal('show');
        };

        this.milestonesSection.editCallback = (milestone) => {
            this.milestoneDialog.resetDialog(milestone);
            $('#editMilestoneDialog').modal('show');
        }

        this.milestonesSection.addCallback = (milestone) => {
            // TODO Switch to modal instead of default confirm
            if (window.confirm(`Create a duplicate of ${milestone.MilestoneCategoryAndName}?`)) {
                $.ajax({
                    url: `/secure/ctms/sites/site-details?handler=AddMilestone`,
                    headers: { "RequestVerificationToken": this.token },
                    type: 'POST',
                    data: milestone,
                    success: (resp) => {
                        this.milestonesSection.loadData();
                    }
                });
            }
        }

        // Action Items
        $(document).on('click', '#actionItemsTable .ctms-icon-pencil', async (evt) => {
            var row = $(evt.target).closest('tr');
            var data = $('#actionItemsTable').DataTable().row(row).data();
            if (!data || !data.Id) return;
            $('#newActionItemDialogLabel').text('Edit Action Item');
            const response = await getData(`/secure/ctms/action-items/action-items?handler=ActionItemDto&id=${data.Id}`);
            if (response && response.success && response.actionItem) {
                if (this.actionItemDialog) {
                    $('#newActionItemDialog').modal('show');
                    this.actionItemDialog.populateDialogFieldsFromDto(response.actionItem);
                    // HACK set search value to filter to site
                    $('#newActionItemDialog #assign-search-input').val(this.siteName).trigger('input');
                }
            } else {
                alert('Could not load action item for editing.');
            }
        });

        $('#aiNewActionItemBtn').on('click', () => {
            $('#newActionItemDialogLabel').text('New Action Item');
            $('#actionItemId').val(0);
            $('#newActionItemDialog #assign-search-input').val(this.siteName).trigger('input');
        });

        // Communications
        $(document).on('click', '#communicationsTable .ctms-icon-pencil', async (evt) => {
            const row = $(evt.target).closest('tr');
            const data = $('#communicationsTable').DataTable().row(row).data();
            if (!data || !data.Id) return;
            $('#newCommunicationEventDialogLabel').text('Edit Communication Event');
            const response = await getData(`/secure/ctms/communications/communications?handler=CommunicationEventDto&id=${data.Id}`);
            if (response && response.success && response.communicationEvent) {
                if (this.communicationDialog) {
                    $('#newCommunicationEventDialog').modal('show');
                    this.communicationDialog.populateDialogFieldsFromDto(response.communicationEvent);
                    // HACK set search value to filter to site
                    $('#newCommunicationEventDialog #filter-sites-search-input').val(this.siteName).trigger('input');
                    $('#communicationDialogTabSection').collapse('show');
                }
            } else {
                alert('Could not load communication event for editing.');
            }
        });

        $('#newCommunicationEventBtn').on('click', () => {
            $('#newCommunicationEventDialogLabel').text('New Communication Event');
            $('#communicationId').val(0);
            $('#newCommunicationEventDialog #filter-sites-search-input').val(this.siteName).trigger('input');
            $('#communicationDialogTabSection').collapse('show');
        });

        // Contacts
        $(document).on('click', '#contactsTable .ctms-icon-pencil', async (evt) => {
            var row = $(evt.target).closest('tr');
            var data = $('#contactsTable').DataTable().row(row).data();
            if (!data || !data.Id) return;
            const contact = await getData(`/secure/ctms/contacts/contacts?handler=ContactDetails&id=${data.Id}`);
            if (this.isNonViewer) {
                this.contactsDialog.populateModal(contact);
            }
            else {
                this.contactsDialog.populateReadonlyModal(contact);
            }
            $('#newContactDialog').modal('show');
        });

        $('#newContactButton').on('click', (evt) => {
            this.contactsDialog.clearContactModal();
            // HACK pre-select the site
            $('#add-site-button').trigger('click');
            $('#site-container select').val(this.siteId);

            $('#newContactDialog').modal('show');
        });

        // Staff
        $('#editStaffButton').on('click', async (evt) => {
            const response = await getData(`/secure/ctms/sites/site-details?handler=ActiveStaff&id=${this.siteId}`);

            if (this.staffDialog) {
                this.staffDialog.populateCheckedUsers(response);
                $('#editStaffDialog').modal('show');
            };
        });

        // Addresses
        $(document).on('click', '#addressesTable .ctms-icon-pencil', async (evt) => {
            var row = $(evt.target).closest('tr');
            var data = $('#addressesTable').DataTable().row(row).data();
            if (!data || !data.Id) return;
            $('#newAddressDialogLabel').text('Edit Address');

            const response = await getData(`/secure/ctms/sites/site-details?handler=AddressDto&id=${data.Id}`);
            if (response && response.success && response.address) {
                if (this.addressDialog) {
                    $('#newAddressDialog').modal('show');
                    this.addressDialog.populateDialogFieldsFromDto(response.address);
                }
            } else {
                alert('Could not load address for editing.');
            }
        });

        $('#newAddressBtn').on('click', () => {
            $('#newAddressDialogLabel').text('New Address');
            $('#addressId').val(0);
            if (this.addressDialog) {
                this.addressDialog.clearDialogFields();
            }
            $('#newAddressDialog').modal('show');
        });

    }

    async loadSiteDetails() {
        const response = await fetch(
            `/secure/ctms/sites/site-details?handler=SiteDetailsSection&id=${this.siteId}`,
            {
                method: 'GET',
                headers: { "RequestVerificationToken": this.token },
            }
        );
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const result = await response.text();
        document.querySelector('#siteDetailsSection').innerHTML = result;
    }

    async reloadMilestoneDetails() {
        const response = await fetch(
            `/secure/ctms/sites/site-details?handler=SiteMilestoneSection&id=${this.siteId}`,
            {
                method: 'GET',
                headers: { "RequestVerificationToken": this.token },
            }
        );
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const result = await response.text();
        document.querySelector('#milestonesSection').innerHTML = result;

        this.milestonesSection.initialize();
        this.milestonesSection.loadData();
    }

    siteDetailsDialogSuccess(response) {
        // Update site name if it changed
        if (this.siteName !== response.SiteName) this.siteName = response.SiteName;
        this.loadSiteDetails();
        this.reloadMilestoneDetails();
    }

    actionItemDialogSuccess(response) {
        this.actionItemSection.loadData();
    }

    contactsDialogSuccess(response) {
        this.contactsSection.loadData();
    }

    statusDialogSuccess(response) {
        this.milestonesSection.loadData();
    }

    milestoneDialogSuccess(response) {
        this.milestonesSection.loadData();
    }

    deliverableDialogSuccess(response) {
        this.deliverablesSection.loadData();
    }

    communicationDialogSuccess(response) {
        this.communicationsSection.loadData();
        this.actionItemSection.loadData();
    }

    staffDialogSuccess(response) {
        this.staffSection.loadData();
    }

    addressDialogSuccess(response) {
        this.addressesSection.loadData();
    }

}